module.exports = "/assets/data/23cb3e6636821fb71f67f598a60ce027-AB24.data.json";